import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLocationShareLocation } from '@rsos/utils/fetchPublicServices';
import { isAPIError } from '@rsos/utils/isAPIError';
import { addLocToQueueSuccess } from '../../../actions';

interface FetchLocationShareLocationInterface {
  callerID: string;
  orgName: string;
  token: string;
}

export const fetchLocationShareLocation = createAsyncThunk(
  'locations/fetchLocationShareLocation',
  async (
    { callerID, orgName, token }: FetchLocationShareLocationInterface,
    { dispatch, rejectWithValue },
  ) => {
    try {
      const response = await getLocationShareLocation({
        callerID,
        orgName,
        token,
      });

      const normalizedLocation = {
        ...response,
        caller_id: callerID,
      };

      dispatch(addLocToQueueSuccess(normalizedLocation));

      return normalizedLocation;
    } catch (error) {
      if (isAPIError(error)) {
        return rejectWithValue(error.message);
      }
    }
  },
);
